<template>
  <el-main class="common-main">
    <div class="container error">
      <img src="../../static/images/404.png" alt="404" class="error-img">
      <div class="error-title">很抱歉！您访问的资源不存在。</div>
      <div class="error-button">
        <el-button type="primary" @click="goIndex">返回首页</el-button>
      </div>
    </div>
  </el-main>
</template>

<script>
export default {
  name: "error",
  head: {
    title: "很抱歉！您访问的资源不存在"
  },
  methods: {
    goIndex() {
      this.$router.push({path: '/'})
    }
  }
}
</script>

<style scoped>
.error {
  text-align: center;
}

.error-img {
  width: 350px;
  margin-top: 100px;
}

.error-title{
  color: #333333;
  margin-top: 50px;
  font-weight: bold;
  font-size: 20px;
}

.error-button{
  margin-top: 30px;
}
</style>